export const ADD_PROMO = "ADD_PROMO";
export const REMOVE_PROMO = "REMOVE_PROMO";
export const ADD_VOUCHER = "ADD_VOUCHER";
export const REMOVE_VOUCHER = "REMOVE_VOUCHER";
export const SET_DELIVERY = "SET_DELIVERY";
export const ADD_DONATION = "ADD_DONATION";
export const REMOVE_DONATION = "REMOVE_DONATION";
export const ADD_POINTS = "ADD_POINTS";
export const REMOVE_POINTS = "REMOVE_POINTS";

export interface AddPromo {
  type: typeof ADD_PROMO;
  payload: {
    code: string;
    amount: number;
    discount: number;
  };
}

export interface RemovePromo {
  type: typeof REMOVE_PROMO;
}

export interface AddVoucher {
  type: typeof ADD_VOUCHER;
  payload: {
    code: string;
    amount: number;
  };
}

export interface RemoveVoucher {
  type: typeof REMOVE_VOUCHER;
  payload: {
    code: string;
  };
}

export interface SetDelivery {
  type: typeof SET_DELIVERY;
  payload: {
    type: string;
    cost: number;
  };
}

export interface AddDonation {
  type: typeof ADD_DONATION;
  payload: {
    amount: number;
  };
}

export interface RemoveDonation {
  type: typeof REMOVE_DONATION;
}

export interface AddPoints {
  type: typeof ADD_POINTS;
  payload: {
    numberOfPoints: number;
    amount: number;
  };
}

export interface RemovePoints {
  type: typeof REMOVE_POINTS;
}

export type Action =
  | AddPromo
  | AddVoucher
  | AddDonation
  | RemovePromo
  | RemoveVoucher
  | RemoveDonation
  | SetDelivery
  | AddPoints
  | RemovePoints;

export const mockStore = {
  order: {
    amount: 0.00,
  },
};

export type State = {
  order: {
    amount: number;
  };
  delivery: {
    type: string;
    cost: number;
  };
  promo: {
    code: string;
    amount: number;
    discount: number;
  };
  donation: {
    amount: number;
  };
  vouchers: {
    code: string;
    amount: number;
  }[];
  rewards4Racing: {
    numberOfPoints: number;
    amount: number;
  };
};

export const reducer = (state: Partial<State> = {}, action: Action) => {
  if (action.type === ADD_PROMO) {
    return {
      ...state,
      promo: action.payload,
    };
  }

  if (action.type === REMOVE_PROMO) {
    return {
      ...state,
      promo: null,
    };
  }

  if (action.type === ADD_VOUCHER) {
    return {
      ...state,
      vouchers: [...(state.vouchers ? state.vouchers : []), action.payload],
    };
  }

  if (action.type === REMOVE_VOUCHER) {
    return {
      ...state,
      vouchers: state.vouchers.filter((voucher) => action.payload.code !== voucher.code),
    };
  }

  if (action.type === ADD_DONATION) {
    return {
      ...state,
      donation: action.payload,
    };
  }

  if (action.type === REMOVE_DONATION) {
    return {
      ...state,
      donation: null,
    };
  }

  if (action.type === ADD_POINTS) {
    return {
      ...state,
      rewards4Racing: action.payload,
    };
  }

  if (action.type === REMOVE_POINTS) {
    return {
      ...state,
      rewards4Racing: null,
    };
  }

  if (action.type === SET_DELIVERY) {
    return {
      ...state,
      delivery: action.payload,
    };
  }

  return state;
};
